import * as types from "./types";

const listMetaInitial = {
  currentPage: 1,
  count: 0,
  pages: 1,
};

const initialState = {
  workingLogs: {
    list: [],
    meta: { ...listMetaInitial },
  },
  workingSlots: {
    list: [],
    meta: { ...listMetaInitial },
  },
  trainingSlots: {
    list: [],
    meta: { ...listMetaInitial },
  },
};

const companyEventTimesheet = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_COMPANY_WORKING_LOGS_REQUEST:
      return {
        ...state,
        workingLogs: {
          ...state.workingLogs,
          list: [],
          meta: { ...listMetaInitial },
        },
      };
    case types.GET_COMPANY_WORKING_LOGS_RESPONSE:
      return {
        ...state,
        workingLogs: {
          list: action.payload.list,
          meta: action.payload.meta,
        },
      };
    case types.GET_COMPANY_WORKING_SLOTS_REQUEST:
      return {
        ...state,
        workingSlots: {
          ...state.workingSlots,
          list: [],
          meta: { ...listMetaInitial },
        },
      };
    case types.GET_COMPANY_WORKING_SLOTS_RESPONSE:
      return {
        ...state,
        workingSlots: {
          list: action.payload.list,
          meta: action.payload.meta,
        },
      };
    case types.GET_COMPANY_TRAINING_WORKING_SLOTS_REQUEST:
      return {
        ...state,
        trainingSlots: {
          ...state.trainingSlots,
          list: [],
          meta: { ...listMetaInitial },
        },
      };
    case types.GET_COMPANY_TRAINING_WORKING_SLOTS_RESPONSE:
      return {
        ...state,
        trainingSlots: {
          list: action.payload.list,
          meta: action.payload.meta,
        },
      };
    default:
      return state;
  }
};

export default companyEventTimesheet;
